import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import 'sweetalert2/dist/sweetalert2.min.css';
import VueSweetalert2 from "vue-sweetalert2";

import { Axios } from "axios";
import VueAxios from "vue-axios";

import { mdiAccount, mdiAccountSettings, mdiBroom, mdiContacts, mdiDelete, mdiDownload, mdiEye, mdiEyeOff, mdiFileDocument, mdiHome, mdiLogout, mdiMagnify, mdiPencil, mdiUpload, mdiTrashCan } from '@mdi/js';
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import "vuetify/styles";


const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      account: mdiAccount,
      eyeon: mdiEye,
      eyeoff: mdiEyeOff,
      logout: mdiLogout,
      config: mdiContacts,
      cloud_upload: mdiUpload,
      reports: mdiFileDocument,
      engine: mdiAccountSettings,
      editpencil: mdiPencil,
      editdelete: mdiDelete,
      vhome: mdiHome,
      search: mdiMagnify,
      clean: mdiBroom,
      download: mdiDownload,
      deleteev: mdiTrashCan
    },
    sets: {
      mdi,
    },
  },
});

createApp(App)
  .use(store)
  .use(vuetify)
  .use(VueSweetalert2)
  .use(VueAxios, Axios)
  .use(router)
  .mount("#app");
